"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterSkillDTO = exports.SkillsTypes = void 0;
const class_validator_1 = require("class-validator");
var SkillsTypes;
(function (SkillsTypes) {
    SkillsTypes["Move"] = "Move";
    SkillsTypes["Punch"] = "Punch";
    SkillsTypes["RangeWeapon"] = "RangeWeapon";
    SkillsTypes["BladeFlurry"] = "BladeFlurry";
    SkillsTypes["SoulSteal"] = "SoulSteal";
    SkillsTypes["MawOfTheWolf"] = "MawOfTheWolf";
    SkillsTypes["GranitFist"] = "GranitFist";
    SkillsTypes["Sprint"] = "Sprint";
    SkillsTypes["Wait"] = "Wait";
    SkillsTypes["Reload"] = "Reload";
    SkillsTypes["PlantBomb"] = "PlantBomb";
    SkillsTypes["DefuseBomb"] = "DefuseBomb";
    SkillsTypes["RegenKit"] = "RegenKit";
    SkillsTypes["RockItBaby"] = "RockItBaby";
    SkillsTypes["BackThrust"] = "BackThrust";
    SkillsTypes["SpitOfTheRaccoon"] = "SpitOfTheRaccoon";
    SkillsTypes["BuildFortification"] = "BuildFortification";
    SkillsTypes["MeleeWeaponSkill"] = "MeleeWeaponSkill";
    SkillsTypes["BladeCircle"] = "BladeCircle";
    SkillsTypes["ClawOfTheWolf"] = "ClawOfTheWolf";
    SkillsTypes["Rifle"] = "Rifle";
    SkillsTypes["SpitOfTheRacoon"] = "SpitOfTheRacoon";
    SkillsTypes["Slash"] = "Slash";
    SkillsTypes["Medigun"] = "Medigun";
    SkillsTypes["SoulTransfer"] = "SoulTransfer";
    SkillsTypes["GranitBreak"] = "GranitBreak";
    SkillsTypes["GranitPressure"] = "GranitPressure";
    SkillsTypes["Hammer"] = "Hammer";
    SkillsTypes["VorpalSword"] = "VorpalSword";
    SkillsTypes["FieldSurgery"] = "FieldSurgery";
    SkillsTypes["FlyOfTheEagle"] = "FlyOfTheEagle";
})(SkillsTypes = exports.SkillsTypes || (exports.SkillsTypes = {}));
let CharacterSkillDTO = (() => {
    class CharacterSkillDTO {
    }
    __decorate([
        class_validator_1.IsEnum(SkillsTypes),
        __metadata("design:type", String)
    ], CharacterSkillDTO.prototype, "skillType", void 0);
    return CharacterSkillDTO;
})();
exports.CharacterSkillDTO = CharacterSkillDTO;
//# sourceMappingURL=Skill.js.map